import { CusaC360B2bCarepakComponent } from "./CusaC360B2bCarepakComponent";

export function CusaC360B2bCarepakScreen() {
  return (
    <>
      <CusaC360B2bCarepakComponent />
    </>
  );
}
